import { render } from "./channel-selector-form.vue?vue&type=template&id=12d50ae4&lang=pug"
import script from "./channel-selector-form.vue?vue&type=script&lang=js"
export * from "./channel-selector-form.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__